import { Injectable } from '@angular/core';
import { commonRoutes } from 'constants/web-app-constants';
import { Observable, of } from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';
import { LoggedInGuard } from './logged-in.guard';

@Injectable({
  providedIn: 'root',
})
export class CustomerGuard extends LoggedInGuard {
  public override checkUrlAllowed(url: string): Observable<boolean> {
    return super.checkUrlAllowed(url).pipe(switchMap((loggedIn) => (loggedIn ? this.#handleLoggedInState() : of(false))));
  }

  readonly #handleLoggedInState = () =>
    this.authService.isCustomer$().pipe(switchMap((isCustomer) => (isCustomer ? this.#handleCustomer() : this.#handlePotentialCustomer())));

  readonly #handleCustomer = () => of(true);

  readonly #handlePotentialCustomer = () =>
    this.authService.isPotentialCustomer().pipe(
      tap((isPotentialCustomer) => isPotentialCustomer && this.router.navigate([commonRoutes.postlogin.onboarding.redirect])),
      switchMap(() => of(true)),
    );
}
